<template>
  <div id="choicePriorityEdit">
    <Panel :title="$t('display_priority')">
      <Draggable v-model="items"  @start="drag=true" @end="drag=false">
        <div v-for="select in items" class="item-checkbox-line">
          <label :for="`chk_${select.id}`">{{getItemName(select.id)}}</label>
          <br/>
        </div>
      </Draggable>
    </Panel>
    <div class="footer-actions" v-if="!$store.getters.isBranchContextInventory">
      <button class="btn btn-primary" @click="save">{{$t("save")}}</button>
    </div>
  </div>
</template>

<script>
  import { Core } from "@/core/Core";
  import Draggable from 'vuedraggable';
  import { mapActions } from 'vuex';

  export default {
    name: "ChoicePriority",

    components: { Draggable },

    data() {
      return {
        ready: false,
        inventory: null,
        items: [],
        data: {
          id: null,
          type: "",
          selected: [],
          itemPriorities: {},
        }
      }
    },

    computed: {
      inventoryReference() {
        return this.$store.state.contextCompany ? this.$store.state.contextCompany.nameCanonical : this.inventory.id;
      }
    },

    async mounted() {
      this.inventory = await this.$store.getters.getContextInventory;
      Promise
        .all([
          Core.request("GET", `/api/inventory/${this.inventoryReference}/choices`),
        ])
        .then(([choice]) => {
          console.log('done with promise' + choice);
          this.items = choice;
        })
        .finally(() => {
          this.$store.commit('showSpinner', false);
        })

    },

    methods: {

      ...mapActions(['saveChoicesPriorities']),

      getItemName(id) {
        for (let item of this.items) {
          if (item.id === id) {
            return this.$to(item.name);
          }
        }
      },
      async save() {
        this.$store.commit("showSpinner", true);
        let response = await this.saveChoicesPriorities({inventoryId: this.inventoryReference, data: {items: this.items}});
        if (!response) {
          toast(this.$t("modifiers.error.save"), "error");
          this.$store.commit("showSpinner", false);
          return;
        }
        this.$store.commit("showSpinner", false);
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
